module.exports = __webpack_public_path__ + "static/img/smartProduct22.838f60cd.jpg";